import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  effect,
  forwardRef,
  input,
  model,
  OnInit,
  signal,
} from '@angular/core';
import { Types } from 'shared-lib';
import { v4 } from 'uuid';
import { ListComponent } from '../list/list.component';
import { IconComponent } from '../icon/icon.component';
import { EComponentSize, EIcon, ELabelType } from '../../types';
import { FormsModule } from '@angular/forms';
import { Functions } from '../../helpers';
import { LabelComponent } from '../label/label.component';
import { helper } from '../../../public-api';

@Component({
  selector: 'ui-text',
  standalone: true,
  imports: [
    forwardRef(() => ListComponent),
    IconComponent,
    FormsModule,
    LabelComponent,
  ],
  templateUrl: './text.component.html',
  styleUrl: './text.component.scss',
})
export class TextComponent implements AfterViewInit {
  placeHolder = model.required<Types.TChoice>();
  value = model<Types.TChoice | Types.TChoice[] | undefined>();
  type = model<Types.EInput>(Types.EInput.TEXT);
  default = model<Types.TChoice>('');
  required = input(false);
  editable = input(false);
  isTemplate = input(false);
  inputType = signal<string>('');
  inputValue = signal<string>('');

  isPasswordVisible = false;
  isPassword = false;
  EIcon = EIcon;
  EComponentSize = EComponentSize;
  ELabelTypes = ELabelType;
  EAlert = Types.EAlert;
  darkMode = false;

  uiId = v4();
  textTypes = [
    Types.EInput.AREA,
    Types.EInput.CNPJ,
    Types.EInput.CPF,
    Types.EInput.EMAIL,
    Types.EInput.NUMBER,
    Types.EInput.PHONE,
    Types.EInput.TEXT,
    Types.EInput.PASSWORD,
    Types.EInput.DATE,
  ];

  constructor() {
    effect(
      () => {
        if (this.value() && !this.inputValue()) {
          this.ngAfterViewInit();
        }
      },
      { allowSignalWrites: true }
    );
  }

  ngAfterViewInit(): void {
    this.darkMode = helper.Functions.isDarkMode();

    if (!this.value() && this.default()) {
      this.value.set(this.default());
    }
    this.inputValue.update((_) => this.value()?.toString() ?? '');

    this.inputType.set(
      this.type() == Types.EInput.EMAIL
        ? 'email'
        : this.type() == Types.EInput.NUMBER
        ? 'number'
        : this.type() == Types.EInput.PHONE
        ? 'phone'
        : this.type() == Types.EInput.AREA
        ? 'textarea'
        : this.type() == Types.EInput.CNPJ
        ? 'cnpj'
        : this.type() == Types.EInput.CPF
        ? 'cpf'
        : this.type() == Types.EInput.PASSWORD
        ? 'password'
        : this.type() == Types.EInput.DATE
        ? 'date'
        : 'text'
    );
    switch (this.type()) {
      case Types.EInput.PASSWORD:
        this.isPassword = true;
        break;

      case Types.EInput.DATE:
        const value = this.value();

        // Verifica se o valor não é undefined e é uma string válida
        if (value && !isNaN(new Date(value as string).getTime())) {
          const dateValue = new Date(value as string); // Converte a string para Date
          const formattedDate = dateValue.toISOString().split('T')[0]; // Formata para 'YYYY-MM-DD'
          this.value.set(formattedDate); // Atualiza o valor
          this.inputValue.update((_) => formattedDate); // Atualiza o valor
        } else {
          console.warn('Valor de data inválido ou undefined');
        }
        break;

      case Types.EInput.CNPJ:
        if (this.value()) {
          this.inputValue.update((_) =>
            Functions.formatCNPJ(this.value()?.toString() ?? '')
          );
        }
        break;

      case Types.EInput.CPF:
        if (this.value()) {
          this.inputValue.update((_) =>
            Functions.formatCPF(this.value()?.toString() ?? '')
          );
        }
        break;

      case Types.EInput.PHONE:
        if (this.value()) {
          this.inputValue.update((_) =>
            Functions.formatPhone(this.value()?.toString() ?? '')
          );
        }
        break;
    }
  }

  togglePasswordVisibility() {
    this.isPasswordVisible = !this.isPasswordVisible;
    if (this.isPasswordVisible) {
      this.inputType.set('text');
    } else {
      this.inputType.set('password');
    }
  }

  getMaxLength(): number | null {
    switch (this.type()) {
      case Types.EInput.CPF:
        return 14;
      case Types.EInput.CNPJ:
        return 18;
      case Types.EInput.PHONE:
        return 15;
      default:
        return null;
    }
  }

  // ZONA: isTemlpate

  onPlaceholderChange(inputValue?: Types.TChoice | Types.TChoice[]) {
    this.placeHolder.set(inputValue as string);
  }

  onTypeChange(inputValue?: Types.TChoice | Types.TChoice[] | undefined) {
    this.type.set(inputValue as Types.EInput);
  }

  onDefaultChange(inputValue?: Types.TChoice | Types.TChoice[]) {
    this.default.set(inputValue as string);
    this.value.set(inputValue as string);
  }

  resetValue() {
    this.value.set('');
  }

  // ZONA: is Edit

  onChange(target?: any) {
    if (!target) return;
    if (
      this.type() == Types.EInput.CNPJ ||
      this.type() == Types.EInput.CPF ||
      this.type() == Types.EInput.PHONE
    ) {
      let rawValue = target.value.replace(/\D/g, '');
      let formattedValue = rawValue;

      switch (this.inputType()) {
        case 'cpf':
          formattedValue = Functions.formatCPF(rawValue);
          break;
        case 'cnpj':
          formattedValue = Functions.formatCNPJ(rawValue);
          break;
        case 'phone':
          formattedValue = Functions.formatPhone(rawValue);
          break;
      }

      this.value.set(rawValue);
      this.inputValue.update((_) => formattedValue);
    } else {
      this.value.set(target.value);
      this.inputValue.update((_) => target.value);
    }
  }
}
